var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "newAppVersion" } }, [
    _c("h1", [_vm._v(_vm._s(_vm.$t("new_app_version_" + _vm.device)))]),
    _c("img", { attrs: { src: require("./media/new-version.png") } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }